var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkOut = function SvgLinkOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 1.563c0 .311.25.562.563.562h2.393L5.85 7.352a.562.562 0 0 0 .795.795l5.227-5.227.002 2.393c0 .311.25.562.563.562.311 0 .562-.25.562-.562v-3.75A.56.56 0 0 0 12.438 1h-3.75a.56.56 0 0 0-.563.563m-5.437.187C1.755 1.75 1 2.505 1 3.438v7.874C1 12.246 1.755 13 2.688 13h7.874c.933 0 1.688-.755 1.688-1.687v-3a.56.56 0 0 0-.562-.563.56.56 0 0 0-.563.563v3c0 .311-.25.562-.562.562H2.686a.56.56 0 0 1-.562-.562V3.436c0-.311.25-.562.563-.562h3a.561.561 0 1 0 0-1.125z"
  })));
};
export default SvgLinkOut;